export const acceptedCurrencies = ['usd'];
export const acceptedPaymentMethods = ['card'];
